export default __webpack_public_path__ + "static/event3-497e9e3f444e4e811738eb11baef6ba1.jpg";